<template>
	<div :class="`mb${gap}`">
		<!-- Headline -->
		<div class="flex xs-12 xs-between">
			<div class="fs5 lh125 fw7 c1 mb2">{{ $t("actions") }}</div>
		</div>

		<!-- Body -->
		<div>
			<div class="xs-12 flex">
				<div class="xs-9 pr4">
					<j-base-select
						v-model="form.actionId"
						:options="options.actions"
						:placeholder="$t('select_action')"
					/>
				</div>
				<div class="flex xs-3 xs-right">
					<j-button
						:isDisabled="form.actionId ? false : true"
						@click="onClickContinue"
						>{{ $t("continue") }}</j-button
					>
				</div>
			</div>
		</div>

		<!-- Modal -->
		<core-modal name="policy_actions" :headline="computedName">
			<div class="p4">
				<component
					:is="form.actionId"
					:policyId="policyId"
					:contractCurrency="contractCurrency"
					@done="onDone"
				/>
			</div>
		</core-modal>
	</div>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect"
import JButton from "@/components/JButton"
import JCard from "@/components/JCard"
import CoreModal from "@/modules/core/components/CoreModal"
import BerkleyPolicyDetailActionsGetPdfFile from "./BerkleyPolicyDetailActionsGetPdfFile.vue"
import BerkleyPolicyDetailActionsIssuePolicy from "./BerkleyPolicyDetailActionsIssuePolicy.vue"

export default {
	components: {
		JBaseSelect,
		JButton,
		JCard,
		CoreModal,
		BerkleyPolicyDetailActionsGetPdfFile,
		BerkleyPolicyDetailActionsIssuePolicy
	},

	props: {
		policyId: {
			type: String
		},

		contractCurrency: {
			type: String
		},

		hasContractHolder: {
			type: Boolean
		},

		/**
		 * Vertical gap between fields
		 * It translates into mb{gap} class
		 */
		gap: {
			type: String,
			default: "4"
		}
	},

	data() {
		return {
			form: {
				actionId: null
			},

			options: {
				actions: [
					{
						name: "Issue Policy",
						value: "BerkleyPolicyDetailActionsIssuePolicy"
					},
					{
						name: "Get PDF File",
						value: "BerkleyPolicyDetailActionsGetPdfFile"
					}
				]
			}
		}
	},

	computed: {
		computedName() {
			return this.options?.actions?.find(
				item => item.value === this.form.actionId
			)?.name
		}
	},

	methods: {
		onClickContinue() {
			if (
				!this.hasContractHolder &&
				this.form.actionId === "ActionIssuePolicy"
			) {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text: this.$t("errors.issue_without_holder")
					}
				})
			} else {
				this.$modal.show("policy_actions")
			}
		},

		onDone() {
			// Hide modal after timeout
			setTimeout(() => this.$modal.hide("policy_actions"), 250)

			// Show success message
			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: "Action was successful, yay!"
				}
			})

			this.$emit("action:done")
		}
	}
}
</script>
